const Laravel = (window as any).Laravel;
import axios from 'axios';

axios.interceptors.request.use((config) => {
    config.headers = config.headers || {};
    config.headers['X-CSRF-TOKEN'] = Laravel.csrfToken;
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    return config;
});

export default axios;
